import { FunctionComponent } from 'react';

import {
  ModalContainer,
  ModalLayoutFullScreen,
} from '@kanda-libs/ks-design-library';

import SatNoteModalHeader from './Header';

import { MODAL_ID } from '../../../constants';
import OpenBankingSatNoteForm from '../../Form';

const OpenBankingSatNoteModal: FunctionComponent = () => (
  <ModalContainer id={MODAL_ID}>
    {({ handleClose }) => (
      <ModalLayoutFullScreen
        noBorder
        header={<SatNoteModalHeader onClick={handleClose} />}
      >
        <div className="flex flex-1 h-full w-full max-w-120 mx-auto">
          <OpenBankingSatNoteForm />
        </div>
      </ModalLayoutFullScreen>
    )}
  </ModalContainer>
);

export default OpenBankingSatNoteModal;
